/* Piropa — grilla de sets con tabs (rediseño WoodMart, Etapa E2 2026-07-23).
   Cambia de panel sin recargar: todos los paneles se renderizan server-side
   (SEO/AEO intactos), el script solo alterna visibilidad + estado aria. */
document.querySelectorAll('[data-piropa-tabs]').forEach(function (root) {
  var buttons = root.querySelectorAll('[data-tab-target]');

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      buttons.forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-selected', 'false');
      });
      root.querySelectorAll('.piropa-tabs__panel').forEach(function (panel) {
        panel.classList.remove('is-active');
        panel.hidden = true;
      });

      btn.classList.add('is-active');
      btn.setAttribute('aria-selected', 'true');

      var target = document.getElementById(btn.getAttribute('data-tab-target'));
      if (target) {
        target.classList.add('is-active');
        target.hidden = false;
      }

      syncArrows(root);
    });
  });

  /* --- Flechas del carrusel (mobile) — 2026-07-24 ---
     La fila de fichas es deslizable con el dedo, pero Cristian no encontraba
     cómo moverse entre productos: en iOS los scrollbars son overlay (no se ven
     en reposo) y la ficha cortada al borde no alcanza como señal. Estas flechas
     son el control explícito. Si el JS no carga, el gesto sigue funcionando y
     las flechas quedan ocultas (nacen con hidden). */
  var prev = root.querySelector('[data-piropa-prev]');
  var next = root.querySelector('[data-piropa-next]');

  function activeGrid(scope) {
    var panel = scope.querySelector('.piropa-tabs__panel.is-active');
    return panel ? panel.querySelector('.product-grid') : null;
  }

  function step(grid) {
    var item = grid.querySelector('.grid__item');
    if (!item) return grid.clientWidth * 0.8;
    var gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
    return item.getBoundingClientRect().width + gap;
  }

  function syncArrows(scope) {
    var grid = activeGrid(scope);
    if (!grid || !prev || !next) return;
    var max = grid.scrollWidth - grid.clientWidth;
    prev.disabled = grid.scrollLeft <= 2;
    next.disabled = grid.scrollLeft >= max - 2;
  }

  if (prev && next) {
    prev.hidden = false;
    next.hidden = false;

    prev.addEventListener('click', function () {
      var grid = activeGrid(root);
      if (grid) grid.scrollBy({ left: -step(grid), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      var grid = activeGrid(root);
      if (grid) grid.scrollBy({ left: step(grid), behavior: 'smooth' });
    });

    root.querySelectorAll('.product-grid').forEach(function (grid) {
      grid.addEventListener('scroll', function () {
        syncArrows(root);
      });
    });

    syncArrows(root);
  }
});
